'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var nthHookSettings = require('@narvar/nth-hook-settings');
var nthHookTheme = require('@narvar/nth-hook-theme');
var React = require('react');
var Divider = require('@narvar/nth-bit-divider');
var index = require('../../components/Language/index.js');
require('../../components/Spinner/Spinner.module.css.js');
require('@babel/runtime/helpers/extends');
require('../../components/LocationCard/LocationCard.js');
require('../../components/PudoCard/PudoCard.js');
require('../../components/ItemCard/ItemCard.js');
require('../../components/SelectItem/SelectItem.js');
require('../../components/SelectList/SelectList.js');
var ErrorBanner = require('../../components/ErrorBanner/ErrorBanner.js');
require('../../components/Footer/Footer.js');
require('../../components/StickyFooter/StickyFooter.js');
require('../../components/SwatchesList/SwatchesList.js');
var index$1 = require('../../components/TextLink/index.js');
require('../../components/Backdrop/Backdrop.module.css.js');
require('../../components/LineItemsGroup/index.js');
require('../../components/Skeleton/Skeleton.module.css.js');
var useLanguage = require('../../hooks/language/useLanguage.js');
var Form = require('./Form.js');
var nthHookTranslations = require('@narvar/nth-hook-translations');
var tokens = require('./tokens.js');
var validateString = require('../../utils/validateString.js');
require('@babel/runtime/helpers/defineProperty');
require('escape-string-regexp');
var OrderLookup_module = require('./OrderLookup.module.css.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);
var Divider__default = /*#__PURE__*/_interopDefaultLegacy(Divider);

const defaultLoginFields = [{
  type: 'ORDER',
  label: 'returnsOrderLoginFormLabelOrder',
  caption: 'returnsOrderLoginFormCaptionOrder',
  error: false
}, {
  type: 'EMAIL',
  label: 'returnsOrderLoginFormLabelEmail',
  caption: 'returnsOrderLoginFormCaptionEmail',
  error: false
}, {
  type: 'GIFT_CODE',
  label: 'returnsOrderLoginFormLabelGiftCode',
  caption: 'returnsOrderLoginFormCaptionGiftCode',
  error: false
}];
const OrderLookupC = _ref => {
  let {
    onChange,
    onClose,
    onSubmit,
    loading,
    error,
    giftReturnEnabled,
    layout = 'default',
    values
  } = _ref;
  const [formFields, setFormFields] = React.useState(defaultLoginFields);
  const [giftReturn, setGiftReturn] = React.useState(false);
  const {
    buttonsPrimaryDefault,
    linksNoneDefault,
    linksNoneHover
  } = nthHookTheme.useTheme();
  const {
    returnPolicy
  } = nthHookSettings.useSettings();
  const {
    rawValue: emailErrorMsg
  } = useLanguage["default"]({
    langKey: 'returnsOrderLoginFormValidationErrorEmail'
  });
  const {
    returnsOrderLoginAbove,
    returnsOrderLoginBelow
  } = nthHookTranslations.useTranslations();
  const langKeyTransform = langKey => giftReturn ? `${langKey}_giftReturn` : langKey;
  const {
    showLink,
    returnPolicyHref
  } = returnPolicy || {};
  // TODO: refactor instead of disable
  // eslint-disable-next-line @typescript-eslint/require-await
  const submitHandler = async event => {
    const updatedFields = formFields.map(field => {
      if (field.type === 'EMAIL') {
        var _event$value;
        const emailInput = (_event$value = event.value) === null || _event$value === void 0 ? void 0 : _event$value.find(input => input.type === field.type);
        const validEmail = validateString.validatePattern((emailInput === null || emailInput === void 0 ? void 0 : emailInput.value) ?? '', validateString.EMAIL_ADDRESS_PATTERN);
        return {
          ...field,
          error: !validEmail,
          errorMsg: emailErrorMsg
        };
      }
      return field;
    });
    setFormFields(updatedFields);
    if (updatedFields.some(_ref2 => {
      let {
        error
      } = _ref2;
      return error;
    })) return;
    onSubmit === null || onSubmit === void 0 ? void 0 : onSubmit(event);
  };
  const handleToggleGiftReturn = () => {
    setGiftReturn(v => !v);
    onClose === null || onClose === void 0 ? void 0 : onClose({
      event: 'cancel',
      area: 'orderLogin',
      subComponent: giftReturn ? 'giftReturn' : 'return',
      value: null
    });
  };
  return /*#__PURE__*/React__default["default"].createElement("div", {
    className: OrderLookup_module["default"].container,
    style: {
      textAlign: layout === 'centered' ? 'center' : 'left'
    }
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsOrderLoginAbove",
    defaultString: returnsOrderLoginAbove
  }), error && /*#__PURE__*/React__default["default"].createElement(ErrorBanner["default"], null, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    noWrap: true,
    langKey: "returnsOrderLoginError"
  })), /*#__PURE__*/React__default["default"].createElement(Form.Form, {
    loading: loading,
    onChange: onChange
    // TODO: refactor instead of disable
    // eslint-disable-next-line @typescript-eslint/no-misused-promises
    ,
    onSubmit: submitHandler,
    giftReturn: giftReturn,
    fields: formFields,
    values: values
  }), showLink && returnPolicyHref && /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    target: '_blank',
    href: returnPolicyHref,
    linkStyle: {
      sDefault: {
        ...buttonsPrimaryDefault,
        color: (buttonsPrimaryDefault === null || buttonsPrimaryDefault === void 0 ? void 0 : buttonsPrimaryDefault.backgroundColor) || '#000000',
        backgroundColor: 'none',
        textTransform: 'none',
        textAlign: 'center',
        margin: '0.5rem auto'
      }
    }
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsOrderLoginReturnPolicy"
  })), giftReturnEnabled && /*#__PURE__*/React__default["default"].createElement("div", {
    className: OrderLookup_module["default"].giftReturnToggleWrapper,
    style: {
      alignItems: layout === 'centered' ? 'center' : 'start'
    }
  }, /*#__PURE__*/React__default["default"].createElement(Divider__default["default"], null), /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: langKeyTransform('returnsOrderLoginToggleGiftReturnTitle')
  }), /*#__PURE__*/React__default["default"].createElement(index$1["default"], {
    linkStyle: {
      sDefault: linksNoneDefault,
      sHover: linksNoneHover
    },
    onClick: handleToggleGiftReturn
  }, /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: langKeyTransform('returnsOrderLoginToggleGiftReturnLinkText')
  }))), /*#__PURE__*/React__default["default"].createElement(index["default"], {
    langKey: "returnsOrderLoginBelow",
    defaultString: returnsOrderLoginBelow
  }));
};
const OrderLookup = nthHookSettings.withSettingsProvider(nthHookTranslations.withTranslationsProvider(nthHookTheme.withThemeProvider(OrderLookupC, {
  themeTokens: ['buttonsPrimaryDefault', 'linksNoneDefault', 'linksNoneHover']
}), {
  translationKeys: tokens.translationKeys
}), {
  settingsRequested: `
    returnPolicy {
      showLink
      returnPolicyHref
    }
  `
});

exports.OrderLookup = OrderLookup;
